import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRoleEnum } from '../enums/user-role.enum';

export const adminOnlyGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  // Get roleIds from localStorage
  const roleIdsString = localStorage.getItem('roleIds');
  
  if (!roleIdsString) {
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  try {
    const roleIds: string[] = JSON.parse(roleIdsString);
    
    // Check if user has Admin role specifically
    const hasAdminRole = roleIds.includes(UserRoleEnum.Admin);
    
    if (hasAdminRole) {
      return true;
    }
    
    // User doesn't have Admin role, redirect to admin applications
    router.navigate(['/admin/applications']);
    return false;
    
  } catch (error) {
    console.error('Error parsing roleIds from localStorage:', error);
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
};
